var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M82.2 90H62V66c0-1.1-0.9-2-2-2H40c-1.1 0-2 0.9-2 2v24H17.8V46.7h-4V92c0 1.1 0.9 2 2 2H40c1.1 0 2-0.9 2-2V68h16v24c0 1.1 0.9 2 2 2h24.2c1.1 0 2-0.9 2-2V46.7h-4V90z","key":0}),React.createElement("path",{"d":"M48.7 6.5L2.2 45l2.6 3.1L50 10.6l45.2 37.5 2.6-3.1L51.3 6.5C50.5 5.8 49.5 5.8 48.7 6.5z","key":1}),React.createElement("text",{"y":"115","fontSize":"5px","fontFamily":"'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif","className":"a","key":2},"  Created by Kuber"),React.createElement("text",{"y":"120","fontSize":"5px","fontFamily":"'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif","className":"a","key":3},"  from the Noun Project")]);
}

Home.defaultProps = {"viewBox":"0 0 100 100","width":"48px","height":"48px"};

module.exports = Home;

Home.default = Home;
